import { render, staticRenderFns } from "./calcVesselsSpeedResult.vue?vue&type=template&id=35430013"
import script from "./calcVesselsSpeedResult.vue?vue&type=script&lang=js"
export * from "./calcVesselsSpeedResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports